export const module = {
  info: {
    name: 'voip-testing-panel-user-setting',
    caption: 'voip testing panel user setting',
    viewGroup: 'general-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
